module.exports = __webpack_public_path__ + "img/android_down.537b69e6.png";